import { t } from "@/i18n-js/instance";

import { getVisibilitySummary } from "../../constants";
import type { SelectableVisibility } from "../../types";
import { VisibilitySummaryRow } from "./VisibilitySummaryRow";

interface VisibilitySummaryProps {
  value: SelectableVisibility;
}

export const VisibilitySummary = ({ value }: VisibilitySummaryProps) => {
  const copy = getVisibilitySummary(value);
  return (
    <div className="flex flex-col gap-y-2 pt-4">
      <VisibilitySummaryRow
        iconName="lock"
        emphasis={t("spaces.form.create.v4.visibility_summary.access_label")}
        text={`${copy.accessLabel}. ${copy.accessText}`}
      />
      <VisibilitySummaryRow
        iconName="eye-open"
        emphasis={t(
          "spaces.form.create.v4.visibility_summary.visibility_label",
        )}
        text={copy.visibilityText}
      />
    </div>
  );
};
